import React, { PureComponent } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import Header from './FileDetailsTable/Header';
import Rows from './FileDetailsTable/Rows';

export default class FileDetailsTable extends PureComponent {
  get headers() {
    return [
      this.props.translate('products.file_information.name'),
      this.props.translate('products.file_information.type'),
      this.props.translate('products.file_information.size')
    ];
  }

  get colSize() {
    return [2, 1, 1];
  }

  get textAlign() {
    return ['left', 'center', 'center'];
  }

  get rows() {
    return this.props.files.map(file => {
      const {
        name,
        type,
        size: { display }
      } = file;

      return [
        { content: name, uppercase: false },
        { content: type, uppercase: true },
        { content: display, uppercase: false }
      ];
    });
  }

  render() {
    const { Table } = UX2.Element;

    return (
      <Table>
        <Header headers={ this.headers } colSize={ this.colSize } textAlign={ this.textAlign } />
        <Rows rows={ this.rows } colSize={ this.colSize } textAlign={ this.textAlign } />
      </Table>
    );
  }
}

FileDetailsTable.propTypes = {
  files: PropTypes.array,
  translate: PropTypes.func
};
